import { eApplicationActions } from '../actions/eApplicationActions';
import { IApplicationActions } from '../actions/IApplicationActions';
import { eSingleFields } from '../state/eSingleFields';
import { IApplicationState } from '../state/IApplicationState';

export const ApplicationReducer = (oldState: IApplicationState, action: IApplicationActions): IApplicationState => {
  switch (action.type) {
    case eApplicationActions.CloseEditSingleFieldAction:
      return {
        ...oldState,
        isEditingSingleField: false,
        editingSingleFieldName: eSingleFields.estimated_property_value,
      };
    case eApplicationActions.OpenEditSingleFieldAction:
      return { ...oldState, isEditingSingleField: true, editingSingleFieldName: action.payload };
    case eApplicationActions.SetOrder:
      return { ...oldState, order: action.payload };
    case eApplicationActions.SetError:
      return { ...oldState, error: action.payload };
  }
};
